import { APP_SHELL_STATE } from './../app-shell.route';
import { StateProvider, UrlRouterProvider } from '@uirouter/angularjs';
import { SchedulerController } from './scheduler.controller';
import { SchedulerService, SCHEDULER_SERVICE } from './scheduler.service';
import { HeaderService, HEADER_SERVICE } from './../core/header.service';
import { registerComponentFromTransition } from "../core/lazy-route.helper";

export const SCHEDULER_STATE = "schedulerstate";

export function configRoute($stateProvider: StateProvider, $urlRouterProvider: UrlRouterProvider) {
    $stateProvider.state(SCHEDULER_STATE, {
        parent: APP_SHELL_STATE,
        views: {
            content: {
                component: "schedulerComponent",
                bindings: {
                    serverTimeInfo: "serverTimeInfo"
                }
            }
        },
        url: "/scheduler",
        lazyLoad: async (transition, state) => {
            const moduleExports: any = await import("./scheduler.component");
            registerComponentFromTransition(transition, "schedulerComponent", moduleExports.schedulerComponentOptions);
            return moduleExports;
        },
        onEnter: [HEADER_SERVICE, (headerService: HeaderService) => {
            headerService.headerTitle = "Task Scheduler"
        }],
        resolve: {
            serverTimeInfo: [SCHEDULER_SERVICE, (schedulerService: SchedulerService) => {
                return schedulerService.getActualServerTime();
            }]
        }
    });
}
configRoute.$inject = ["$stateProvider", "$urlRouterProvider"];


// WEBPACK FOOTER //
// ./app/scheduler/scheduler.router.ts